import * as React from 'react';
import { Image, UIHeading3 } from '@cian/ui-kit';

import { IPromoBanner } from '../../../types/newbuildingBanners/promoBanner';
import { TBannerTheme } from '../utils/bannerTypeToTheme';
import { Banner } from '../Banner/Banner';

import * as styles from './NewbuildingBrokerBanner.css';

interface INewbuildingBrokerBannerProps extends IPromoBanner {
  theme: TBannerTheme;
  button: React.ReactNode;
}

export const NewbuildingBrokerBanner = ({ imageUrl, title, theme, button }: INewbuildingBrokerBannerProps) => {
  return (
    <Banner
      theme={theme}
      title=""
      imageUrl={null}
      labels={null}
      subtitle=""
      customClassName={styles['custom-container']}
      customContent={
        <div className={styles['custom-content']}>
          <Image src={imageUrl ?? ''} objectFit="contain" height="auto" />
          <div className={styles['title']}>
            <UIHeading3 color="text-inverted-default">{title}</UIHeading3>
          </div>
        </div>
      }
      footer={
        <div className={styles['footer-button']} onMouseDown={event => event.stopPropagation()}>
          {button}
        </div>
      }
    />
  );
};
